
define( 'FORCES_AND_MOTION_BASICS/../nls/el/forces-and-motion-basics-strings',{
          "none": "Μικρή",
          "force": "Δύναμη",
          "values": "Τιμές",
          "frictionTitle": "Τριβή",
          "redWins": "Οι κόκκινοι κερδίζουν!",
          "frictionForce": "Δύναμη τριβής",
          "pause": "Παύση",
          "friction": "Τριβή",
          "accelerationLab": "Εργαστήριο επιτάχυνσης",
          "forces-and-motion-basics.name": "Δυνάμεις και κίνηση: Τα βασικά",
          "appliedForce": "Εφαρμοσμένη δύναμη",
          "leftForce": "Αριστερή δύναμη",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Δεξιά δύναμη",
          "acceleration": "Επιτάχυνση",
          "sound": "Ήχος",
          "lots": "Μεγάλη",
          "forces": "Δυνάμεις",
          "motion": "Κίνηση",
          "tugOfWar": "Διελκυστίνδα",
          "go": "Πάμε!",
          "newtons.n": "Νιούτονς (N)",
          "sumOfForcesEqualsZero": "Άθροισμα δυνάμεων = 0",
          "blueWins": "Οι μπλε κερδίζουν!",
          "speed": "Ταχύτητα",
          "sumOfForces": "Άθροισμα δυνάμεων",
          "return": "Επιστροφή",
          "translation.credits": "Γιάννης Κασκαμανίδης",
          "newtons": "Νιούτονς",
          "masses": "Μάζες",
          "forceReadout.pattern": "{0}N"
        } );